import clsx from "clsx";
import React from "react";

interface CircularLoaderProps {
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}
const Index: React.FC<CircularLoaderProps> = ({ className, size = "md" }) => {
  const sizeClasses = {
    sm: "w-4 h-4 border-2",
    md: "w-8 h-8 border-2",
    lg: "w-12 h-12 border-3",
    xl: "w-16 h-16 border-4",
  };

  return (
    <div
      className={clsx(
        "animate-spin rounded-full border-solid border-[#fff]",
        "border-t-[#5DA2FF4D] border-r-[#5DA2FF] border-b-[#5DA2FF] border-l-transparent",
        sizeClasses[size],
        className
      )}
    />
  );
};

export default Index;
